import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useGallery() {
    const [photos, setPhotos] = useState(null);
    const [error, setError] = useState(false);

    const reload = useCallback(async () => {
        try {
            const { data } = await api.get("/gallery");
            setPhotos(data);
            setError(false);
        } catch {
            setError(true);
            setPhotos([]);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return { photos, error, reload, setPhotos };
}
